module.exports = __webpack_public_path__ + "static/media/ver2.71e69d5b.jpg";